import React, { useState } from 'react';
import './Header.scss';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerHeight = 64; // 4rem = 64px (assuming 1rem = 16px)
      const elementPosition = element.offsetTop - headerHeight;
      
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
    // Close mobile menu after clicking
    setIsMenuOpen(false);
  };

  const handleNavClick = (e, sectionId) => {
    e.preventDefault();
    scrollToSection(sectionId);
  };

  return (
    <header className="header">
      <div className="header__container">
        {/* Top row with logo and hamburger */}
        <div className="header__top-row">
          <div 
            className="header__logo"
            onClick={() => scrollToSection('splash')}
            style={{ cursor: 'pointer' }}
          >
            Spiritual Direction Studio
          </div>
          
          {/* Hamburger Menu Button */}
          <button
            onClick={toggleMenu}
            className="header__hamburger"
          >
            <svg
              className="header__hamburger-icon"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isMenuOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        <nav className={`header__mobile-nav ${isMenuOpen ? 'open' : ''}`}>
          <ul className="header__mobile-nav-list">
            <li>
              <a 
                href="#splash" 
                className="header__mobile-nav-link"
                onClick={(e) => handleNavClick(e, 'splash')}
              >
                Home
              </a>
            </li>
            <li>
              <a 
                href="#welcome" 
                className="header__mobile-nav-link"
                onClick={(e) => handleNavClick(e, 'welcome')}
              >
                Welcome
              </a>
            </li>
            <li>
              <a 
                href="#qualifications" 
                className="header__mobile-nav-link"
                onClick={(e) => handleNavClick(e, 'qualifications')}
              >
                Qualifications
              </a>
            </li>
            <li>
              <a 
                href="#letsmeet" 
                className="header__mobile-nav-link"
                onClick={(e) => handleNavClick(e, 'letsmeet')}
              >
                Let's Meet
              </a>
            </li>
            <li>
              <a 
                href="#movingforward" 
                className="header__mobile-nav-link"
                onClick={(e) => handleNavClick(e, 'movingforward')}
              >
                Moving Forward
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header; 